module.exports = __webpack_public_path__ + "img/slide5.26ca66e6.png";